// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryTitle_title__5wyKY"};